import React from 'react';
import Screensavers from "../applications/Screensavers"
import '../App.css';

export default class Screensaver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      desktopSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
    this.changeDesktopSize = this.changeDesktopSize.bind(this);
    this.hideScreensaver = this.hideScreensaver.bind(this);
    this.showScreensaver = this.showScreensaver.bind(this);
    window.addEventListener('resize', this.changeDesktopSize);
    window.addEventListener("mousemove", this.hideScreensaver);
    window.addEventListener("keydown", this.hideScreensaver);
    var newTimer = setInterval(this.showScreensaver, 12000);
  }

  changeDesktopSize() {
    this.setState({
      desktopSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  }

  hideScreensaver() {
    clearInterval(this.newTimer);
    if(document.getElementById("screensaver").style.display !== "none") {
      document.getElementById("screensaver").style.display="none";
    }
  }

  showScreensaver() {
    if(document.getElementById("screensaver").style.display !== "flex") {
      document.getElementById("screensaver").style.display="flex";
    }
  }

  render() {
    return(
      <div id="screensaver" data-testid="screensaver" onmousemove="hideScreensaver()">
        <Screensavers
          appLauncherHandler = {null}
          filename = ""
          propMethod = {null}
          width = {this.state.desktopSize.width}
          height = {this.state.desktopSize.height}
        />
      </div>
    );
  }
}
